import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cbe90d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "div-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"calc(100vh - 180px)","padding":"10px","box-sizing":"border-box"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "eguid-map",
    style: {"width":"100%","height":"100%"},
    class: "eguid-map"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"calc(100vh - 180px)","padding":"10px","box-sizing":"border-box","overflow":"auto"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"32px","padding":"10px"} }, [
    /*#__PURE__*/_createElementVNode("p", null, "OpenLayers是一个开源的JavaScript库，，能够在Web网页上浏览地图的库。提供了丰富的地图功能和交互工具，能够在网页上浏览展示地图、添加图层、标记位置、进行地图操作等。"),
    /*#__PURE__*/_createElementVNode("h4", null, "OpenLayers核心类"),
    /*#__PURE__*/_createElementVNode("p", null, "Openlayers最核心类的分别为Map、View、Controls、Layer、Source。基本上所有事件与动作都是围绕这五类展开。"),
    /*#__PURE__*/_createElementVNode("h4", null, "OpenLayers的优点"),
    /*#__PURE__*/_createElementVNode("p", null, "1、开源：OpenLayers是一个开源项目，可以免费使用和修改。 跨平台：OpenLayers可以在各种浏览器和设备上运行，包括桌面和移动设备。"),
    /*#__PURE__*/_createElementVNode("p", null, "2、可定制性：OpenLayers提供了丰富的API和插件，使开发者可以根据自己的需求进行定制和扩展。"),
    /*#__PURE__*/_createElementVNode("p", null, "3、多种地图源支持：OpenLayers支持多种地图源，包括Google Maps、Bing Maps、OpenStreetMap等，使开发者可以根据需要选择合适的地图源。"),
    /*#__PURE__*/_createElementVNode("p", null, "4、丰富的地图功能：OpenLayers提供了丰富的地图功能，包括缩放、平移、标记、测量、查询等，使开发者能够创建交互式的地图应用程序。"),
    /*#__PURE__*/_createElementVNode("p", null, " 你可以通过以下链接获取更多关于OpenLayers的信息："),
    /*#__PURE__*/_createElementVNode("p", null, "官方网站：https://openlayers.org/"),
    /*#__PURE__*/_createElementVNode("p", null, "GitHub仓库：https://github.com/openlayers/openlayers")
  ])
], -1))

import '../ace.config';
import { VAceEditor } from "vue3-ace-editor";
import { onMounted, ref } from 'vue';
import {initMap} from '@/commons/map/xyz-gaode-map'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

onMounted(() => {
  initMap();
});
const content = ref(`<template>
  <div class="home">
    <div id="eguidMap" class="eguid-map"></div>
  </div>
</template>

<script>
import 'ol/ol.css'
import * as control from 'ol/control'
import { Map, View } from 'ol/index'
import { Tile as TileLayer } from 'ol/layer'
import { XYZ } from 'ol/source'

function initMap() {
  const map = new Map({
    target: 'eguidMap',
    controls: control.defaults({ attribution: false, zoom: true, rotate: true }),
    view: new View({
      center: [119, 32],
      maxZoom: 21,
      zoom: 8,
      minZoom: 7,
      projection: 'EPSG:4326'
    })
  })
  // 添加高德地图图层
  const xyzLayer = new TileLayer({
    source: new XYZ({
      url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
    }),
    projection: 'EPSG:3857'
  })
  map.addLayer(xyzLayer)
}
export default {
  name: 'eguidMapView',
  components: {
  },
  mounted() {
    initMap()
  }
}
<\/script>

<style>
.eguid-map {
  width: 800px;
  height: 600px;
  padding: 0;
  margin: 0;
}
</style>

`)
const activeName2 = ref("first"); //tabs
const tabHandleClick = (tab: any, event: any) => {
  console.log(activeName2);
};

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_tabs, {
                modelValue: activeName2.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName2).value = $event)),
                class: "demo-tabs",
                onTabClick: tabHandleClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "地图样例",
                    name: "first"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "OpenLayers介绍",
                    name: "second"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})